import styled from 'styled-components';

export const Container = styled.div`
  padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.xs};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.radii.md};
  background: ${props => props.theme.colors.surface};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  > input {
    -webkit-appearance: none;
    border: none;
    outline: none;
    background: transparent;
    color: ${props => props.theme.colors.textPrimary};
    font-size: ${props => props.theme.typography.sizes.sm};

    :focus,
    :active {
      -webkit-appearance: none;
      outline: none;
      border: none;
    }
  }

  &:focus-within {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(46, 144, 250, 0.2);
  }
  input[type='date']::-webkit-clear-button {
    display: none;
  }
  input[type='date']::-ms-clear {
    display: none;
  }
`;
